import { EntityBase } from "./EntityBase";
import { FuelType } from "./FuelType";
import { LoadZone } from "./LoadZone";
import { RateClass } from "./RateClass";
import { State } from "./State";

export class Utility extends EntityBase {
    name: string = null!;
    active: boolean = null!;
    isDefault: boolean = null!;
    URL: string = null!;
    state: State = null!;
    accountTemplate: string | null = null;
    logo: string | null = null;
    logoCommunity: string | null = null;
    fuelTypes: FuelType[] = null!;
    loadZones: LoadZone[] = null!;
    rateClasses: RateClass[] = null!;
    defaultLoadZone: LoadZone | null = null;
    defaultRateClassForResidential: RateClass | null = null;
    defaultRateClassForCommercial: RateClass | null = null;
}
